import { gql } from "@apollo/client";

export const GET_MY_IN_PROGRESS_CHALLENGES = gql`
  query MyInProgressChallenges {
    myInProgressChallenges {
      id
      status
      joinedAt
      completedAt
      depositAmount
      prizeAmount
      run {
        id
        startAt
        endAt
        campaign {
          id
          productName
          productImageUrl
          channel
          paybackPrice
          originalPrice
          discountPrice
        }
      }
    }
  }
`;

export const GET_MY_COMPLETED_CHALLENGES = gql`
  query MyCompletedChallenges {
    myCompletedChallenges {
      id
      status
      joinedAt
      completedAt
      depositAmount
      prizeAmount
      run {
        id
        startAt
        endAt
        campaign {
          id
          productName
          productImageUrl
          channel
          paybackPrice
          originalPrice
          discountPrice
        }
      }
    }
  }
`;
